import { Entity, Field } from "typegraph";
import { ID } from "common/entities/IEntity";
import Product from "./Product";
import { Subscription } from "./Subscription";
import LaunchURL from "common/entities/LaunchURL";
import Tag from "./Tag";

@Entity({one: "entry"})
export default class Entry {

	@Field()
	public id: ID;

	@Field()
	public displayName: string;

	@Field({entity: Product})
	public product: Product;

	@Field({entity: Subscription})
	public subscription: Subscription;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field({
		entity: Tag,
		includeIf: (data: any) => !!data.loadTags,
		params: ({tagSetIds}: any) => {
			if (!tagSetIds || tagSetIds.length < 1) {
				return {params: {}};
			}

			return { params: { tagSetIds } };
		}
	})
	public tags: null | Tag[];

}


// WEBPACK FOOTER //
// ./src/panels/catalog/entities/Entry.ts